import type { ComponentProps } from 'react';
import React from 'react';
import type { Nullable } from 'corgi-types';

import { useLocalization } from '../../providers/LocaleProvider';
import { RoundedButtonLink } from '../Button/RoundedButton';
import { Flex } from '../Flex';
import { HomeClubBanner } from '../HomeClubBanner';
import { HeadlineH8, SubtitleST4 } from '../Typography';

const containerStyles: ComponentProps<typeof Flex> = {
  flexDirection: 'column',
  padding: 'sp_16',
  borderRadius: 'medium',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'sys.neutral.border.weak',
  mb: 'sp_16',
};

export const DisclaimerContent = ({
  hasHomeclubCondition,
  legalDisclaimerContent,
}: {
  hasHomeclubCondition: boolean;
  legalDisclaimerContent: Nullable<string>;
}) => {
  const { t } = useLocalization();

  return (
    <Flex flexDirection="column" p="sp_16">
      {hasHomeclubCondition && (
        <Flex {...containerStyles}>
          <HomeClubBanner />
          <SubtitleST4
            color="sys.neutral.text.default"
            pb="sp_12"
            dangerouslySetInnerHTML={{
              __html: t('h24_hc_modal_description'),
            }}
          />
          <RoundedButtonLink
            py="sp_10"
            px={['sp_10', 'sp_16']}
            href={t('h24_banner_voucher_drawer_hc_cta_href')}
          >
            <HeadlineH8 color="sys.neutral.text.default">
              {t('h24_more_info_or_become_a_member')}
            </HeadlineH8>
          </RoundedButtonLink>
        </Flex>
      )}
      {legalDisclaimerContent}
    </Flex>
  );
};

export default DisclaimerContent;
